const CapitalizeFirstLetter = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

export default CapitalizeFirstLetter;
